import { SortDirection } from "@tanstack/react-table";
import { Icon } from "PFComponents/icon";

import css from "../table.module.scss";

type TableSortingProps = {
  isSorted: false | SortDirection;
};

export const TableSorting = ({ isSorted }: TableSortingProps) => (
  <div className={css.sorting}>
    {(!isSorted || isSorted === "asc") && <Icon name="caret-up" size="xxxs" />}
    {(!isSorted || isSorted === "desc") && <Icon name="caret-down" size="xxxs" />}
  </div>
);
